import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-modal-body',
  imports: [],
  templateUrl: './modal-body.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './modal-body.component.scss'
})
export class ModalBodyComponent {

}